import { NavLink } from '@models/navlink.model';

export const MenuBackoffice: NavLink[] = [
  {
    title: 'Attendance',
    path: 'atendimento',
    icon: 'happy-support',
    params: 'attendance',
    iconPath: 'assets/icons/happy-support-icon.svg',
    children: [
      {
        title: 'Access contract',
        path: 'atendimento/acessar-contrato',
        children: [],
        roles: ['100988']
      },
      {
        title: 'Operações em lote',
        params: 'batch-operations',
        children: [
          {
            title: 'Transferência de veículos',
            params: 'vehicle-transfer',
            path: 'atendimento/operacoes-lote/transferencia-veiculos',
            roles: ['100987']
          },
          {
            title: 'Histórico de transferências de veículos',
            params: 'history-transfer',
            path: 'atendimento/operacoes-lote/transferencia-veiculos/historico',
            roles: ['100986']
          },
        ],
      },
    ],
  },
  {
    title: 'Logistics',
    path: 'logistica',
    params: 'logistics',
    icon: 'logistics-pins',
    iconPath: 'assets/icons/logistic-pins-icon.svg',
    children: [
      {
        title: 'Estoque Logístico de Tags',
        path: 'logistica/estoque-logistica',
        params: 'logistic-stock',
        roles: ['100985']
      },
      {
        title: 'Tag orders - Customer',
        params: 'tag-order',
        children: [
          {
            title: 'Pedidos',
            params: 'orders',
            path: 'logistica/pedidos-tag',
            roles: ['100984']
          },
          {
            title: 'Histórico de importações',
            params: 'imports',
            path: 'logistica/historico-importacoes',
            roles: ['100983']
          },
        ],
      },
    ],
  },
  {
    title: 'Financial',
    path: 'financeiro',
    icon: 'money-bag',
    iconPath: 'assets/icons/money-bag-icon.svg',
    children: [
      {
        title: 'Partners Transfer Conciliation',
        path: 'financeiro/conciliacao-repasse-parceiros',
        roles: ['100982']
      },
      {
        title: 'Transaction conciliation',
        path: 'financeiro/conciliacao-transacao',
        roles: ['100981']
      },
      {
        title: 'Prepaid',
        params: 'prepaid',
        children: [
          {
            title: 'Chargeback',
            path: 'financeiro/chargeback',
            roles: ['100980']
          },
          {
            title: 'Credit card transactions',
            path: 'financeiro/transacoes-cartao-de-credito',
            roles: ['100979']
          },
        ],
      },
      {
        title: 'Holidays calendar',
        path: 'financeiro/calendario-de-feriados',
        roles: ['100978']
      },
      {
        title: 'Expired Toll Voucher Trips',
        path: 'financeiro/viagens-expiradas',
        roles: ['100977']
      },
      {
        title: 'Reajustes e isenções',
        params: 'readjustments-and-exemptions',
        children: [
          {
            title: 'Índices',
            path: 'financeiro/reajustes-isencoes/indices',
            roles: ['100973']
          },
          {
            title: 'Contratos aniversariantes',
            path: 'financeiro/reajustes-isencoes/contratos-aniversariantes',
            roles: ['100975']
          },
        ],
      },
      {
        title: 'Faturas',
        path: 'financeiro/faturas/contrato',
        roles: ['100974']
      },
    ],
  },
  {
    title: 'Contract Management',
    path: 'gestao-contratos',
    icon: 'document-sheet',
    iconPath: 'assets/icons/document-sheet-icon.svg',
    children: [
      {
        title: 'Change postpaid credit limit',
        path: 'gestao-contratos/alteracao-contratual',
        roles: ['100971']
      },
      {
        title: 'Financial postpaid block',
        params: 'financial-postpaid-block',
        children: [
          {
            title: 'Financial blocking and unblocking',
            params: 'financial-blocking-unblocking',
            path: 'gestao-contratos/bloqueio-financeiro-pospago/acessar-contrato',
            roles: ['100970']
          },
          {
            title: 'Baixar relatório de configurações de bloqueio clientes',
            params: 'download-blocking-configuration-report',
            path: '/menu-inicial',
            roles: ['100969'],
            action: true
          }
        ],
      },
      {
        title: 'Insurance Glass',
        params: 'insurance-glass',
        children: [
          {
            title: 'Insurance Glass Management',
            path: 'gestao-contratos/seguro-vidros',
            roles: ['100968']
          },
          {
            title: 'Download active insurance glass report',
            params: 'download-insurance-glass-report',
            path: '/menu-inicial',
            roles: ['100967'],
            action: true
          },
        ],
      }
    ],
  },
  {
    title: 'Access Management',
    path: 'gestao-acessos',
    icon: 'person-settings',
    iconPath: 'assets/icons/person-settings-icon.svg',
    children: [
      {
        title: 'Relationship consultant',
        params: 'relationship-consultant',
        children: [
          {
            title: 'Consultant register',
            path: 'gestao-acessos/cadastrar-consultor',
            roles: ['100966']
          },
          {
            title: 'Consultant view',
            path: 'gestao-acessos/visualizar-consultor',
            roles: ['100965']
          },
        ]
      },
      {
        title: 'Users',
        params: 'manager-users',
        children: [
          {
            title: 'Clients',
            path: 'gestao-acessos/usuarios/listar-clientes',
            roles: ['100961']
          },
          {
            title: 'Colaboradores',
            path: 'gestao-acessos/usuarios/listar-colaboradores',
            roles: ['100962']
          }
        ]
      }
    ]
  },
  {
    title: 'Gestão de VPO',
    path: 'gestao-vpo',
    icon: 'toll-gate',
    iconPath: 'assets/icons/toll-gate-icon.svg',
    children: [
      {
        title: 'Fornecedores de vale-pedágio obrigatório',
        params: 'toll-voucher-providers',
        children: [
          {
            title: 'Cadastrar fornecedor',
            path: 'gestao-vpo/fornecedores-vale-pedagio/cadastrar-fornecedor',
            roles: ['100964']
          },
          {
            title: 'Consultar fornecedores cadastrados',
            path: '/menu-inicial',
            roles: ['100963'],
            action : true
          },
          {
            title: 'Acessar portal do parceiro',
            path: 'gestao-vpo/fornecedores-vale-pedagio/vale-pedagio',
            roles: ['103004']
          },
          {
            title: 'Usuários FVPO',
            path: 'gestao-vpo/usuarios/listar-fvpo',
            roles: ['103009']
          }
        ]
      },
      {
        title: 'Lista de Transportadores - Rota Livre',
        path: 'gestao-vpo/transportadores-rota-livre',
        roles: ['102000'] 
      },
      {
        title: 'Parceiros Taggy',
        params: 'taggy-partners',
        children: [
          {
            title: 'Consultar Parceiros Taggy cadastrados',
            path: '/menu-inicial',
            roles: ['103006'],
            action : true
          }
        ]
      }
    ]
  },
];

